import { Box, Typography } from '@mui/material';
import { bool, number, oneOfType, string } from 'prop-types';
import React, { memo } from 'react';
import { I18n } from 'utils/i18n';
import getMoment from 'utils/getMoment';
import Badge from './Badge';

const Label = ({
  messagesUnreadCount,
  mandatoriesUnreadCount = 0,
  pinned,
  createdAt = null,
  children,
}) => {
  const date = getMoment(createdAt);
  const time = date?.calendar(null, {
    sameDay: 'LT',
    lastDay: `[${I18n.t('ChannelsPanel.Yesterday')}]`,
    lastWeek: 'dddd',
    sameElse: 'L',
  });
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
      }}
    >
      <Typography
        component="div"
        sx={{
          width: '210px',
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
          fontWeight: '500',
        }}
      >
        {children}
      </Typography>
      <Typography
        variant="caption"
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end',
          width: 84,
        }}
      >
        <Box
          component="span"
          sx={{
            textAlign: 'right',
            width: 60,
            whiteSpace: 'nowrap',
          }}
        >
          {time}
        </Box>
        <Badge
          mandatoriesUnreadCount={mandatoriesUnreadCount}
          messagesUnreadCount={messagesUnreadCount}
          pinned={pinned}
        />
      </Typography>
    </Box>
  );
};

Label.propTypes = {
  messagesUnreadCount: number.isRequired,
  mandatoriesUnreadCount: number,
  createdAt: oneOfType([string, number]),
  children: string.isRequired,
  pinned: bool.isRequired,
};
const isEqual = (prev, next) => {
  if (prev.children !== next.children) return false;
  if (prev.createdAt !== next.createdAt) return false;
  if (prev.pinned !== next.pinned) return false;
  if (prev.mandatoriesUnreadCount !== next.mandatoriesUnreadCount) return false;
  return prev.messagesUnreadCount === next.messagesUnreadCount;
};

export default memo(Label, isEqual);
